const authStateReducer = (state = {}, action) => {
	switch (action.type) {
		case "SET_AUTH_STATE":
			return action.authState || state;
		default:
			return state;
	}
};
export default authStateReducer;
